"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "UpdateWebhookHandler", {
    enumerable: true,
    get: function() {
        return UpdateWebhookHandler;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _hookhandlerservice = require("~/services/hook-handler.service");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let UpdateWebhookHandler = class UpdateWebhookHandler {
    static async beginUpdate(payload, rowId) {
        const webhookHandler = new UpdateWebhookHandler(payload, rowId);
        await webhookHandler.sendBeforeUpdateWebhook();
        return webhookHandler;
    }
    getData() {
        return {
            prevData: this.prevData,
            nextData: this.nextData
        };
    }
    // // experimental, will be useful after refactoring
    // public static async manageWebhook(
    //   payload: WebhookContext,
    //   prevData: any,
    //   handler: () => Promise<void> | Promise<any>,
    // ) {
    //   const webhookHandler = await this.beginUpdate(payload, prevData);
    //   const handlerResult = await handler();
    //   await webhookHandler.finishUpdate();
    //   return handlerResult;
    // }
    async sendBeforeUpdateWebhook() {
        const hookName = `before.${this.webhookContext.isSingleUpdate === false ? 'bulkUpdate' : 'update'}`;
        this.prevData = await this.webhookContext.baseModel.readByPk(this.rowId, false, {}, {
            ignoreView: true,
            apiVersion: _nocodbsdk.NcApiVersion.V3
        });
        if (this.webhookContext.ignoreWebhook !== false) {
            this.sendWebhook(hookName, this.prevData);
        }
    }
    async finishUpdate() {
        const hookName = `after.${this.webhookContext.isSingleUpdate === false ? 'bulkUpdate' : 'update'}`;
        this.nextData = await this.webhookContext.baseModel.readByPk(this.rowId, false, {}, {
            ignoreView: true,
            apiVersion: _nocodbsdk.NcApiVersion.V3
        });
        if (this.webhookContext.ignoreWebhook !== false) {
            this.sendWebhook(hookName, this.prevData, this.nextData);
        }
    }
    sendWebhook(hookName, prevData, nextData) {
        _Noco.default.eventEmitter.emit(_hookhandlerservice.HANDLE_WEBHOOK, {
            context: _extends({}, this.webhookContext.context, {
                cache: false,
                cacheMap: undefined
            }),
            hookName,
            prevData,
            newData: nextData,
            user: this.webhookContext.user,
            viewId: this.webhookContext.baseModel.getViewId(),
            modelId: this.webhookContext.baseModel.model.id,
            tnPath: this.webhookContext.baseModel.tnPath
        });
    }
    constructor(webhookContext, rowId){
        this.webhookContext = webhookContext;
        this.rowId = rowId;
        this.webhookContext = webhookContext;
        this.rowId = rowId;
    }
};
